var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSec8Img(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.1071 60.75V72.3214C78.1071 73.8559 77.4976 75.3275 76.4125 76.4125C75.3275 77.4976 73.8559 78.1071 72.3214 78.1071H60.75M60.75 2.89285H72.3214C73.8559 2.89285 75.3275 3.50242 76.4125 4.58745C77.4976 5.67248 78.1071 7.1441 78.1071 8.67857V20.25M2.89285 20.25V8.67857C2.89285 7.1441 3.50242 5.67248 4.58745 4.58745C5.67248 3.50242 7.1441 2.89285 8.67857 2.89285H20.25M20.25 78.1071H8.67857C7.1441 78.1071 5.67248 77.4976 4.58745 76.4125C3.50242 75.3275 2.89285 73.8559 2.89285 72.3214V60.75M40.5 37.6071C43.5689 37.6071 46.5122 36.388 48.6822 34.2179C50.8523 32.0479 52.0714 29.1046 52.0714 26.0357C52.0714 22.9668 50.8523 20.0235 48.6822 17.8535C46.5122 15.6834 43.5689 14.4643 40.5 14.4643C37.4311 14.4643 34.4878 15.6834 32.3178 17.8535C30.1477 20.0235 28.9286 22.9668 28.9286 26.0357C28.9286 29.1046 30.1477 32.0479 32.3178 34.2179C34.4878 36.388 37.4311 37.6071 40.5 37.6071ZM62.5031 63.6429C61.0076 58.9825 58.0711 54.9174 54.1167 52.0333C50.1623 49.1493 45.3944 47.5952 40.5 47.5952C35.6056 47.5952 30.8376 49.1493 26.8833 52.0333C22.9289 54.9174 19.9924 58.9825 18.4969 63.6429H62.5031Z",
    stroke: "black",
    strokeWidth: 5.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec8Img);
export default __webpack_public_path__ + "static/media/sec8img.1a89cc156a16fd047768a0ee76bc888a.svg";
export { ForwardRef as ReactComponent };